/**
 * VoucherBatch entity class
 */

import moment from 'moment'

/**
 * VoucherBatchFactory
 * returns VoucherBatch entity class
 *
 * @class VoucherBatchFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.VoucherBatch} class
 *
 * @ngdoc factory
 * @name mwApp.factory:VoucherBatchFactory
 */
/* @ngInject */
export default function VoucherBatchFactory ($http, Entity, onOffMixin) {
  /* === VoucherBatch class === */

  /**
   * VoucherBatch model
   *
   * @class VoucherBatch
   * @classdesc VoucherBatch model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.VoucherBatch} VoucherBatch entity
   */
  function VoucherBatch () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  VoucherBatch.prototype = Object.create(Entity.prototype)
  VoucherBatch.prototype.constructor = VoucherBatch

  /* === VoucherBatch instance methods & fields === */

  Object.assign(VoucherBatch.prototype, {

    /**
     * instance fields
     *
     * @memberof models.VoucherBatch#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      $distributor: 'Distributor',
      activeVouchersCount: Number,
      createdBy: String,
      createdTime: moment,
      enabled: Boolean,
      expiredVouchersCount: Number,
      length: Number,
      lengthType: String,
      pendingVouchersCount: Number,
      progress: String, // VOUCHERBATCH_STATUSES
      slotCount: Number,
      soldVouchersCount: Number,
      subscription: 'Subscription',
      voucherCount: Number,
      vouchersLeftCount: Number
    },

    /**
     * url template
     *
     * @memberof models.VoucherBatch#
     * @type {String}
     */
    _urlTemplate: 'api/distributors/{{::$distributor.id}}/batches/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.VoucherBatch#
     * @type {String}
     */
    _publicUrlTemplate: 'distributors/{{::$distributor.id}}/batches/{{::id}}',

    /**
     * get progress field value
     * @param cast
     * @returns {Promise}
     */
    _getProgressState: function (cast) {
      return VoucherBatch
        .loadRaw({
          id: this.id,
          $distributor: this.$distributor,
          url: '\\progress'
        }, cast)
    }

  }, onOffMixin)

  /* === VoucherBatch static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(VoucherBatch, Entity)
  VoucherBatch._name = 'VoucherBatch'
  VoucherBatch.init()

  /**
   * Set selected pending batches as expired.
   *
   * @memberof models.VoucherBatch
   * @param {Object} params
   * @param {number} params.distributorId - distributor id
   * @param {number[]} params.batchIds - batch ids to expire
   * @return {Promise}
   */
  VoucherBatch.expirePending = function ({ distributorId, batchIds }) {
    const url = `api/distributors/${distributorId}/batches/pending/expire`
    return $http.put(url, { voucherBatchIds: batchIds })
  }

  // permissions
  VoucherBatch.access = {
    view: 'viewVoucherBatch',
    create: 'createVoucherBatch',
    edit: 'editVoucherBatch',
    delete: 'deleteVoucherBatch'
  }

  // permissions
  VoucherBatch.extra = {
    slotsAllowedCount: Number,
    VoucherBatchProgress: String,
    createAllowed: Boolean,
    subscriptions: ['Subscription']
  }

  return VoucherBatch
}
